import axiosConfig from '../axiosConfig';
import { GenericResponse } from '../types/generic-response';
import { TZone } from '../zone/Zone';

export type TSubscriber = {
	id: string;
	subscription: string;
	zone: number | TZone;
	status: string;
	subscribed_at: number;
	revoked_at: number;
};

export type TNewSubscriber = Omit<TSubscriber, 'id' | 'revoked_at' | 'subscribed_at'>;

export class Subscriber implements TSubscriber {
	id: string;
	subscription: string;
	zone: number | TZone;
	status: string;
	subscribed_at: number;
	revoked_at: number;

	constructor(sub: TSubscriber) {
		this.id = sub.id;
		this.subscription = sub.subscription;
		this.status = sub.status;
		this.zone = sub.zone;
		this.subscribed_at = sub.subscribed_at;
		this.revoked_at = sub.revoked_at;
	}

	public static GetAll(expand: (keyof TSubscriber)[] = []): Promise<TSubscriber[]> {
		return axiosConfig.instance
			.get(`/admin/subscribers`, { params: { expand: expand } })
			.then((res) => {
				return ((res.data || []) as TSubscriber[]).map((entity) => {
					return entity;
				});
			});
	}

	public static New(entity: TNewSubscriber): Promise<TSubscriber> {
		return axiosConfig.instance.post(`admin/subscriber`, entity).then((res) => {
			return res.data as TSubscriber;
		});
	}

	public static Update(entity: TSubscriber): Promise<TSubscriber> {
		return axiosConfig.instance.patch('admin/subscriber', entity).then((res) => {
			return res.data as TSubscriber;
		});
	}

	public static ApplyOrUpgrade(subscriberId: string): Promise<GenericResponse<TSubscriber>> {
		return axiosConfig.instance.get(`/admin/subscriber/${subscriberId}/push`).then((res) => {
			return res.data as Promise<GenericResponse<TSubscriber>>;
		});
	}
}
